/**
 * A-009B — Display helpers for canonical payload presentation fields.
 * Prefer backend `formatted` strings. Do not invent currency rules here.
 */

export function moneyLabel(block, key, placeholder = "—") {
  if (!block) return placeholder;
  const formatted = block.formatted;
  if (formatted && Object.prototype.hasOwnProperty.call(formatted, key)) {
    const value = formatted[key];
    if (value === null || value === undefined) {
      return placeholder;
    }
    return value;
  }
  return placeholder;
}

export function payloadCurrency(payload) {
  if (payload && payload.meta && payload.meta.currency) {
    return payload.meta.currency;
  }
  if (payload && payload.currency) {
    return payload.currency;
  }
  if (payload && payload.order && payload.order.currency) {
    return payload.order.currency;
  }
  if (payload && payload.cart && payload.cart.currency) {
    return payload.cart.currency;
  }
  return null;
}
